import { Form, Image, InputGroup, Modal } from 'react-bootstrap';
import './LoginForm.scss'
import { ILoginForm } from '../../utils/interfaces/ILoginForm';
import AwayterConnect from './../../utils/resources/awayter_connect_light_cropped.png'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Tutorial from '../Tutorial/Tutorial.component';

const LoginForm = (props: { cancelRecoveryClick: (e: any) => void, errorLogin: boolean, loadingRecovery: boolean, loginSubmit: (e: any) => void, recoveryPwdSubmit: (e: any) => void, loading: boolean, loginInfo: ILoginForm, onChangeForm: (e: any) => void, onDemoLogin: () => void }) => {
    const [passwordVisibility, setPasswordVisibility] = useState(false)
    const [recoveryPwd, setRecoveryPwd] = useState(false)
    const navigate = useNavigate();

    const onLoginForm = (e: any) => {
        e.preventDefault();
        props.loginSubmit(e);
    }

    const cancelRecoveryClicked = () => {
        setRecoveryPwd(false)
        props.cancelRecoveryClick(false)
    }

    const onSendRecoveryPwd = (e: any) => {
        e.preventDefault(); // Evita la recarga del formulario
        if (props.loginInfo.email.length > 0) {
            props.recoveryPwdSubmit(e);
        }
    }

    const onRecoveryClick = () => {
        setRecoveryPwd(true);
    }

    const [showModal, setShowModal] = useState(localStorage.getItem('tutorial') !== 'visitat');
    const handleCloseModal = () => {
        setShowModal(false)
        localStorage.setItem('tutorial', "visitat")
    }
    return (
        <div className='background-image-container'>

            <div className='p-5 loginDiv' >
                <Image src={AwayterConnect} className='img-fluid mb-3' />

                {props.errorLogin && <div className="alert alert-danger" role="alert">
                    Incorrect user or password
                </div>}

                {!recoveryPwd && (
                    <Form className='form mt-3' onSubmit={onLoginForm}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Control type="email" name='email' placeholder="Email" value={props.loginInfo.email} onChange={props.onChangeForm} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <InputGroup className='password'>
                                <Form.Control type={passwordVisibility ? "text" : "password"} name='password' placeholder="Password" value={props.loginInfo.password} onChange={props.onChangeForm} />
                                <InputGroup.Text onClick={() => setPasswordVisibility(!passwordVisibility)} >
                                    <i className={passwordVisibility ? 'bi bi-eye-slash' : 'bi bi-eye'} > </i>
                                </InputGroup.Text>
                            </InputGroup>
                        </Form.Group>

                        <div className="text-center">
                            <button className='mb-2 w-100 btn-Custom  text-black' style={{ backgroundColor: "var(--IDGrey)" }} type="submit">
                                {props.loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>}
                                {!props.loading && 'Login'}
                            </button>
                            <span className='recoveryPwd' onClick={onRecoveryClick}>
                                Have you forgotten your password?
                            </span>
                            <hr className='formLine' />
                            <button className='mt-2 w-100 btn-Custom btn-IDGreen text-white' style={{ backgroundColor: "var(--IDLightBlack" }} type="button" onClick={() => navigate('/signup')}>
                                {props.loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>}
                                {!props.loading && 'Try the Demo – Free Register'}
                            </button>
                            <button className="btn-Help-Fixed" type='button' onClick={() => setShowModal(true)}>
                                <i className="bi bi-question-lg"></i>
                            </button>
                            <Tutorial showModal={showModal} setShowModal={handleCloseModal} />
                        </div>
                    </Form>
                )}

                {recoveryPwd && (
                    <div className="text-center">
                        <span className='recoveryPwd'>{props.loadingRecovery ? "Check your email" : "Enter your email to receive a new password"}</span>
                        <Form className='form mt-3' onSubmit={onSendRecoveryPwd}>
                            {!props.loadingRecovery &&
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="email" name='email' placeholder="Email" value={props.loginInfo.email} onChange={props.onChangeForm} />
                                </Form.Group>}
                            <button className='mb-2 w-100 btn-Custom btn-IDGreen' disabled={props.loadingRecovery} type="submit">
                                {props.loadingRecovery && props.loginInfo.email.length > 0 ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : "Send"}
                            </button>
                            <hr className='mt-3 formLine' />
                            <button className='mt-2 w-100 btn-Custom btn-IDGrey' type="button" onClick={cancelRecoveryClicked}>
                                Back to login
                            </button>
                        </Form>
                    </div>
                )}

            </div>

        </div>
    );
}

export default LoginForm;
